/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import customModal from "../customModal/customModal.vue";

export default {
  name: "labTestVersion",
  emits: ['close'],
  components: {
    customModal,
  },
  emits: ["close", "saved"],
  props: {
    labCode: {
      type: String,
      required: true,
    },
    testCode: {
      type: String,
      required: true,
    },
    oldVersionNo: {
      type: String,
      default: "",
    },
    currentVersion: {
     type: String,
      default: "",
    },
    studyId: {
      type: String,
      required: true,
    },
    unitselected: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      version: "",
      effectiveDate: "",
      copyVersion:"",
      isActive: true,
      baseurl: process.env.VUE_APP_Service_URL,
      errors: [],
      unit: this.unitselected || "",
      token: "",
      isFirstVersion: true,
      existingVersions: [],
    };
  },
  async mounted() {
    this.token = store.getters.getIdToken;
    this.isFirstVersion = !this.oldVersionNo && !this.currentVersion;
     if (!this.unit && this.unitselected) {
    this.unit = this.unitselected;
    }
    await this.loadExistingVersions();
  },
  methods: {
   async loadExistingVersions() {
  try {
    const response = await axios.get(
      `${this.baseurl}/management/labreferencerange/getlabreferenceversionbyid`,
      {
        params: {
          labcode: this.labCode,
          testcode: this.testCode,
          studyid: this.studyId
        },
        headers: {
          Authorization: "Bearer " + this.token,
        },
      }
    );
    
    const data = response.data || {};
    
    if (data.versions && Array.isArray(data.versions)) {
      this.existingVersions = data.versions
        .filter(version => version.version && version.version.trim())
        .map(version => version.version.trim());
      
      console.log("Loaded existing versions:", this.existingVersions);
    } else {
      this.existingVersions = [];
    }
    if (this.currentVersion && this.currentVersion.trim()) {
      this.existingVersions.push(this.currentVersion.trim());
    }
    if (this.oldVersionNo && this.oldVersionNo.trim()) {
      this.existingVersions.push(this.oldVersionNo.trim());
    }
    
  } catch (error) {
    console.error("Error loading existing versions:", error);
    this.existingVersions = [];
  }
},

   validate() {
  this.errors = [];

  if (!this.version || this.version.trim() === "") {
    this.errors.push(this.$t("navigations.version") + " " + this.$t("navigations.is required"));
  } else {
    const trimmedVersion = this.version.trim();
    if (this.existingVersions.includes(trimmedVersion)) {
      this.errors.push("Version number already exists.");
    }
    
  
  }
  

  if (!this.unit || this.unit.trim() === "") {
    this.errors.push(this.$t("navigations.unit") + " " + this.$t("navigations.is required"));
  }

  if (!this.effectiveDate) {
    this.errors.push(this.$t("navigations.effective date") + " " + this.$t("navigations.is required"));
  } else if (!moment(this.effectiveDate, "YYYY-MM-DD", true).isValid()) {
    this.errors.push(this.$t("navigations.invalid effective date"));
  }

  return this.errors.length === 0;
},

    async saveVersionDetails() {
      if (!this.validate()) {
        alert(this.errors.join("\n"));
        return;
      }

      if (!this.isFirstVersion) {
        const confirmation = confirm(
          "Are you sure you want to create a new version? The existing reference ranges and validation rules will be replicated."
        );
        if (!confirmation) return;
      }

      this.version = this.version.trim();

      const payload = {
        labCode: this.labCode,
        testCode: this.testCode,
        oldVersionNo: this.oldVersionNo,
        newVersionNo: this.version,
        currentVersion: this.version,
        effectiveDate: new Date(this.effectiveDate).toISOString(),
        unit: this.unit,
        isActive: this.isActive,
        studyId: this.studyId,
      };

      try {
        await axios.post(
          `${this.baseurl}/management/labreferencerange/newversion`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + this.token,
              "Content-Type": "application/json",
            },
          }
        );
        
        if (this.isFirstVersion) {
          alert("Version created successfully");
        } else {
          alert(this.$t("navigations.version added successfully"));
        }
        
        let newlyCreatedarray = [this.version, this.unit];
        this.existingVersions.push(this.version);
        
        this.$emit("saved", newlyCreatedarray);
        this.$emit("close");
        this.$emit("showSetVersion", true);
        
        this.isFirstVersion = false;
      } catch (err) {
        let errorMessage = this.$t("navigations.version save failed");
        let showAlert = false;

        if (err.response?.data?.messages?.length) {
          let fullMsg = err.response.data.messages[0];
          let shortMsg = fullMsg.includes(":") ? fullMsg.split(":")[1].trim() : fullMsg;
          shortMsg = shortMsg.split("\n")[0].trim();

          if (/Version already exists/i.test(fullMsg)) {
            errorMessage = "Version already exists. Please use a different version number.";
            showAlert = true;
            await this.loadExistingVersions();
          } else if (/No matching records found for versioning/i.test(fullMsg)) {
            errorMessage = "No matching records found for versioning.";
            this.$emit("saved", this.version);
            this.$emit("showSetVersion", true);
          } else {
            console.error("Server Error:", shortMsg);
          }
        } else if (err.response?.data?.detail) {
          errorMessage = err.response.data.detail;
          console.error("Error detail:", err.response.data.detail);
        } else {
          console.error("Unhandled Error:", err);
        }

        if (showAlert) {
          alert(errorMessage);
        }
      }
    }
  },
};
